import React from 'react'

import { SideSummary } from '@components/common'

import { useTierContext } from '../../hooks/useTierContext'

export const Analytics = () => {
  const { tier } = useTierContext()

  if (!tier) return null

  return (
    <SideSummary>
      <SideSummary.Item title="Analytics">
        {tier.statistics.membersCount} total members
      </SideSummary.Item>
    </SideSummary>
  )
}
